// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"558":"650762f9","939":"37d955d8"}[chunkId] + ".chunk.js";
};